// extracted by mini-css-extract-plugin
module.exports = {"container":"_76eeb82","tableImage":"_e752fff","logo":"_317948c","seat":"_60f5254","dealerButton":"_93c59d8","seatButton":"_0a43e0c"};